import { useQueryClient } from "@tanstack/react-query";
import { addHospitalityListing } from "../../api";
import { AddHospitalityListingDTO } from "../../dtos";
import { AxiosResponse } from "axios";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useAddHospitalityListing() {
  const queryClient = useQueryClient();

  return useDomainMutation<
    AxiosResponse,
    { response?: { data?: { message?: string } } },
    AddHospitalityListingDTO
  >({
    mutationFn: (data: AddHospitalityListingDTO) =>
      addHospitalityListing(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["track"] });
      queryClient.invalidateQueries({ queryKey: ["hospitality-listings"] });
    },
  });
}
